export default __webpack_public_path__ + "static/media/colored-quiz-icon.cb8a008b.svg";